module.exports = __webpack_public_path__ + "static/media/fallFoliage.b664cf2e.svg";